import adminApi from "./adminApi";

export const adminLogin = (password) =>
    adminApi.post("/admin/login", { password });

export const listInventory = () =>
    adminApi.get("/admin/inventory");

export const addInventory = (payload) =>
    adminApi.post("/admin/inventory", payload);

// DELETE requests carry a body under `data` in axios, not as a
// second positional argument - this is what lets the admin
// password reach requireAdminPasswordConfirmation server-side.
export const deleteInventory = (serial, confirmPassword) =>
    adminApi.delete(`/admin/inventory/${serial}`, { data: { confirmPassword } });

export const forceUnlink = (serial, confirmPassword) =>
    adminApi.delete(`/admin/inventory/${serial}/owner`, { data: { confirmPassword } });

export const setDelivered = (serial, delivered) =>
    adminApi.patch(`/admin/inventory/${serial}/delivered`, { delivered });

// confirmPassword is only checked server-side when deactivating
// (activated: false) - sending it on activate too is harmless,
// the middleware ignores it in that case.
export const setActivated = (serial, activated, confirmPassword) =>
    adminApi.patch(`/admin/inventory/${serial}/activated`, { activated, confirmPassword });

export const listFirmwareReleases = () =>
    adminApi.get("/admin/firmware");

export const registerFirmwareRelease = (payload) =>
    adminApi.post("/admin/firmware", payload);

export const deleteFirmwareRelease = (version) =>
    adminApi.delete(`/admin/firmware/${version}`);

export const pushFirmwareUpdate = (payload) =>
    adminApi.post("/admin/firmware/push", payload);
